// extracted by mini-css-extract-plugin
export default {"font12":"12px","font13":"13px","font14":"14px","font16":"16px","font18":"18px","font24":"24px","font30":"30px","font36":"36px","font40":"40px","fontsizerem":"1.5rem"};